//MODULES
export * from '../incident-accident/components/incident-accident-create/incident-accident-create.component';
export * from '../incident-accident/components/incident-accident-edit/incident-accident-edit.component';
export * from '../incident-accident/components/incident-accident-list/incident-accident-list.component';
export * from '../incident-accident/pages/index/incident-accident.component';
export * from './company-type/company-type-create.component';
export * from './company-type/company-type-edit.component';
export * from './company-type/company-type-list.component';
export * from './company-type/company-type.component';
export * from './custom-type/custom-type-create.component';
// export * from './custom-type/custom-type-list.component';
export * from './custom-type/custom-type-edit.component';
export * from './customers/customers-create-edit.component';
export * from './customers/customers-list.component';
//CUSTOMERS
export * from './customers/customers.component';
export * from './daily-report-recipients/daily-report-recipients.component';
export * from './departments/departments-create.component';
export * from './departments/departments-edit.component';
export * from './departments/departments.component';
export * from './email/account-email-template.component';
export * from './email/email-template-list.component';
//EMAIL TEMPLATES
export * from './email/email-template.component';
//FORGOT
export * from './forgot-credentials/forgot-credentials.component';
// export * from './custom-type/custom-type.component';
export * from './guards/guard-create.component';
export * from './guards/guard-edit.component';
export * from './guards/guard-list.component';
export * from './guards/guard.component';
export * from './incident-types/incident-type-field-setting/incident-type-datasource-editor.component';
export * from './incident-types/incident-type-field-setting/incident-type-field-setting.component';
// export * from './incident-types/incident-types-create.component';
export * from './incident-types/incident-types-edit.component';
export * from './incident-types/incident-types-list.component';
// export * from './incident-types/incident-types.component';
export * from './management/account-module/accounts-module-list.component';
//MANAGEMENT
export * from './management/account-module/accounts-module.component';
// export * from './accounts/accounts-edit.component';
// export * from './accounts/accounts-list.component';
//ACCOUNT SETTINGS
export * from './management/account-settings/account-settings.component';
export * from './management/user-module-role/user-module-role.component';
export * from './mobile/daily-report/daily-report-create.component';
export * from './mobile/daily-report/daily-report-edit.component';
export * from './mobile/daily-report/daily-report-list.component';
export * from './mobile/issue/issue-create.component';
export * from './mobile/landing.component';
//MOBILE
//LOANS
export * from './mobile/loans/loans-create.component';
export * from './mobile/loans/loans-landing.component';
export * from './mobile/loans/loans-list.component';
export * from './mobile/loans/loans-preview.component';
export * from './mobile/loans/loans-return.component';

export * from './modules/modules-list.component';
export * from './modules/modules.component';
export * from './setting/setting-edit.component';
export * from './setting/setting-list.component';
export * from './setting/setting.component';
export * from './sites/sites-create.component';
export * from './sites/sites-edit.component';
//SITES
export * from './sites/sites.component';
export * from './taglogs/tag-logs-create.component';
export * from './taglogs/tag-logs-edit.component';
export * from './taglogs/tag-logs-list.component';
export * from './taglogs/tag-logs.component';
export * from './tags/tags-create.component';
export * from './tags/tags-edit.component';
export * from './tags/tags-list.component';
export * from './tags/tags.component';
export * from './type3/type3-create.component';
export * from './type3/type3-edit.component';
export * from './type3/type3-list.component';
export * from './type3/type3.component';
export * from './type4/create-form/type4-create-form.component';
export * from './type4/edit-form/type4-edit-form.component';
export * from './type4/list/type4-list.component';
export * from './type4/type4.component';
// export * from './users/users-list.component';
//USERS
// export * from './users/users.component';
export * from './users/users-create.component';
export * from './users/users-edit.component';




// WEBPACK FOOTER //
// ./src/app/components/index.ts